import type { AuthUser } from '@stayon/auth-core';
import { isPlatformWorkspace, isWorkspaceAdmin } from '@/shared/auth';

/**
 * Spiegelt `RequirePlatformWorkspaceOrSupportSession` samt der Rolle am Controller. Das
 * Mapping-Fenster ist eine Sitzung im Konto des Kanalmanagers: es öffnen der Plattform-Workspace
 * und der StayOn-Support während einer Support-Sitzung, dort für die Objekte des Kunden. Ein Kunde
 * ohne Sitzung bekäme verlässlich 403 und sieht deshalb keinen Knopf.
 */
export function canOpenChannelMapping(user: AuthUser | null): boolean {
  return isWorkspaceAdmin(user) && (isPlatformWorkspace(user) || Boolean(user?.supportSessionId));
}
